export default __webpack_public_path__ + "imgs/participants.a23b7c7aaece0ba39352ffcc61d60c6a.svg";